import React, { useState, useEffect } from 'react';
import { Typography, Button, Accordion, AccordionSummary, AccordionDetails, Grid, TextField, IconButton, InputAdornment, Box } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
// import Currency from '../images/Foreign-Currency_35.jpg';
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SearchIcon from "@mui/icons-material/Search";
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import RemoveCircleOutlineRoundedIcon from '@mui/icons-material/RemoveCircleOutlineRounded';
import Highlight from 'react-highlighter';

function Help() {
  const initializeExpansionStatus = () => {
    return Array.apply(null, Array(24)).map(() => false);
  };

  const [expansionStatus, setExpansionStatus] = useState(initializeExpansionStatus());
  const [scrollPosition, setScrollPosition] = useState(0);
  const [displayUpButton, setDisplayUpButton] = useState(false);
  const [search, setSearch] = useState('');

  const handleScroll = () => {
    setScrollPosition(window.pageYOffset);
  };

  const checkScroll = () => {
    if (scrollPosition > 15) {
      setDisplayUpButton(true);
    } else {
      setDisplayUpButton(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    checkScroll();
  }, [scrollPosition]);

  const handleExpansionChange = (panel) => () => {
    const newExpansionStatus = [...expansionStatus];
    newExpansionStatus[panel] = !newExpansionStatus[panel];
    setExpansionStatus(newExpansionStatus);
  };

  const expandAllCollapseAll = (expandAll) => () => {
    const newExpansionStatus = Array.apply(null, Array(24)).map(() => expandAll);
    setExpansionStatus(newExpansionStatus);
  };

  const searchHandler = (event) => {
    const newExpansionStatus = Array.apply(null, Array(24)).map(() => true);
    setSearch(event.target.value);
    setExpansionStatus(newExpansionStatus);
  };

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  };

  const landingSx = {
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top center",
    backgroundSize: "cover",
    float: 'left',
    width: '100%',
  };

  const landingHeaderSx = {
    display: 'flex',
    width: '100%',
    background: 'transparent',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
  };

  const rootSx = {
    flexGrow: 1,
    marginBottom: '16px',
  };

  const topheaderSx = {
    padding: '0px 33px 3px 40px',
  };

  const currencytextSx = {
    color: '#1E1E1E',
    fontWeight: 'bold',
    fontSize: { xs: 15, sm: 'inherit' },
  };

  const currencytext1Sx = {
    color: '#1E1E1E',
    fontWeight: 'bold',
    display: { xs: 'none', sm: 'block' },
  };

  const searchLabelSx = {
    color: '#1E1E1E',
    fontWeight: '654',
  };

  const mainTitleSx = {
    color: '#003366',
    fontWeight: '654',
    margin: '26px 0 2px 0',
    fontSize: {
      xs: '1rem',
      sm: '1.125rem',
      md: '1.5rem',
      lg: '1.625rem',
    },
  };

  const subpaperSx = {
    width: '93.5%',
    paddingTop: '20px',
    paddingBottom: '20px',
    marginLeft: '32px',
    marginRight: '16px',
    color: 'text.primary',
    position: 'relative',
    overflow: 'hidden'
  };

  const buttonExpandCollapseSx = {
    paddingBottom: '10px',
    width: '100%'
  };

  const buttonSx = {
    marginLeft: 2,
    marginRight: 1,
    width: '140px',
    height: '45px',
    borderRadius: '16px',
    backgroundColor: '#324bb5',
    color: 'white',
    fontFamily: 'Roboto Medium, Roboto Regular, Roboto',
    fontSize: '0.875rem',
    fontWeight: '600',
    textTransform: 'none'
  };

  const gridPanelSx = {
    marginBottom: '6px',
    paddingRight: { xs: '8px' },
    marginRight: { xs: '8px' },
  };

  const expansionPanelSx = {
    backgroundColor: '#f1f1f1',
    minWidth: {
      xs: '420px',
      sm: '580px',
      md: '842px',
      lg: '842px',
    },
  };

  const expansionPanelSummarySx = {
    backgroundColor: '#bdbdbd',
    border: '1px',
    borderColor: '#ddd',
    borderRadius: '5px',
    color: '#333',
    minHeight: '30px',
    maxHeight: '43px',
  };

  const faqTitleSx = {
    paddingLeft: '8px',
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#000000'
  };

  const expansiondetailSx = {
    display: 'grid',
    backgroundColor: '#f1f1f1',
    borderRadius: '12px',
  };

  const scrollToTopSx = {
    zIndex: '999',
    position: 'fixed',
    margin: 'auto',
    right: '-7px',
    bottom: '300px',
    width: '60px',
    height: '60px',
    background: '#3c27ad',
    color: '#fff',
    padding: 0,
    fontSize: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    cursor: 'pointer'
  };

  const scrollToTopTextSx = {
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '0.7rem',
    lineHeight: 1
  };

  return (
    <Box sx={landingSx}>
      <Box sx={landingHeaderSx}>
        <Grid sx={rootSx} >
          <Grid container sx={{...topheaderSx, alignItems: "center", flexDirection: "row", justifyContent: "space-between"}}>
            <Grid>
              <Grid container sx={{alignItems: "flex-start", flexDirection: "row", justifyContent: "flex-start"}}>
                <Grid sx={currencytextSx} >FinCEN Form 105</Grid>
                <Grid sx={currencytext1Sx} ><span>&nbsp;</span>| Currency and Monetary Instrument Report (CMIR)</Grid>
              </Grid>
            </Grid>
            <Grid>
              <Typography sx={{...searchLabelSx, textAlign: 'right'}}>
                <TextField
                  label="Search FAQ"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton>
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    )
                  }} onChange={searchHandler}
                  value={search}
                />
              </Typography>
            </Grid>
          </Grid>

          <Typography sx={{...mainTitleSx, textAlign: 'center'}}>Frequently Asked Questions</Typography>
          <Grid container sx={{...subpaperSx, alignItems: "center", flexDirection: "column", flexWrap: "nowrap", justifyContent: "space-between"}}>
            <Grid sx={{...buttonExpandCollapseSx, textAlign: "center"}}>
              <Button sx={buttonSx} onClick={expandAllCollapseAll(true)}>Expand All</Button>
              <Button sx={buttonSx} onClick={expandAllCollapseAll(false)}>Collapse All</Button>
              {/* <Button className={classes.button} variant="contained" color="primary" onClick={() => this.selectPersonalOrBusiness('P')} >Personal</Button> */}
            </Grid>
            <Grid sx={gridPanelSx}>
              <Accordion sx={expansionPanelSx} expanded={expansionStatus[0]} onChange={handleExpansionChange(0)}>
                <AccordionSummary sx={expansionPanelSummarySx}>
                  {expansionStatus[0] ? <RemoveCircleOutlineRoundedIcon /> : <AddCircleOutlineRoundedIcon />}
                  <Typography sx={faqTitleSx}><Highlight search={search}>1.What is the purpose of this form?</Highlight></Typography>
                </AccordionSummary>
                <AccordionDetails sx={expansiondetailSx}>
                  <Typography><Highlight search={search}>The Financial Crimes Enforcement Network (FinCEN) Form 105 (also called Currency and Monetary Instruments Report) is required for persons who are transporting or mailing currency or monetary instruments over $10,000 USD into or out of the United States, as required under the </Highlight> <a rel="noopener noreferrer" target="_blank" href={'https://en.wikipedia.org/wiki/Bank_Secrecy_Act'}> Currency and Foreign Transaction Reporting Act (or Bank Secrecy Act)</a>. <Highlight search={search}>The mission of FinCEN is to safeguard the financial system from illicit use, combat money laundering, and promote national security through the strategic use of financial authorities and the collection, analysis, and dissemination of financial intelligence.</Highlight></Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid sx={gridPanelSx}>
              <Accordion sx={expansionPanelSx} expanded={expansionStatus[1]} onChange={handleExpansionChange(1)}>
                <AccordionSummary sx={expansionPanelSummarySx}>
                  {expansionStatus[1] ? <RemoveCircleOutlineRoundedIcon /> : <AddCircleOutlineRoundedIcon />}
                  <Typography sx={faqTitleSx}><Highlight search={search}>2.	Why do I have to provide this information?</Highlight></Typography>
                </AccordionSummary>
                <AccordionDetails sx={expansiondetailSx}>
                  <Typography><Highlight search={search}>This report is required by 31 U.S.C. 5316, 31 CFR 1010.306, and Treasury Department regulations (31 CFR Chapter X).  Pursuant to the requirements of Public law 93-579 (Privacy Act of 1974), the authority to collect information on Form 105 in accordance with 5 U.S.C. 552a(e)(3) is Public law 91-508; 31 U.S.C. 5316; 5 U.S.C. 301; Reorganization Plan No.1 of 1950; Treasury Department Order No. 165, revised, as amended; 31 CFR Chapter X; and 44 U.S.C. 3501.
                    The principal purpose for collecting the information is to assure maintenance of reports or records where such reports or records have a high degree of usefulness in criminal, tax, or regulatory investigations or proceedings. The information collected may be provided to those officers and employees of the U.S. Customs and Border Protection (CBP) and any other constituent unit of the Department of the Treasury who have a need for the records in the performance of their duties. The records may be referred to any other department or agency of the Federal Government upon the request of the head of such department or agency. The information collected may also be provided to appropriate state, local, and foreign criminal law enforcement and regulatory personnel in the performance of their official duties.
                    Disclosure of this information is mandatory pursuant to 31 U.S.C. 5316 and 31 CFR Chapter X. Failure to provide all or any part of the requested information may subject the currency or monetary instruments to seizure and forfeiture, as well as subject the individual to civil and criminal liabilities. Disclosure of the Social Security Number is mandatory. The authority to collect this number is 31 U.S.C. 5316(b) and 31 CFR 1010.306(d). The Social Security Number will be used as a means to identify the individual who files the record.
                    The collection of this information is mandatory pursuant to 31 U.S.C. 5316, of Title II of the Bank Secrecy Act, which is administered by Treasury’s Financial Crimes Enforcement Network (FinCEN).
                  </Highlight></Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid sx={gridPanelSx}>
              <Accordion sx={expansionPanelSx} expanded={expansionStatus[2]} onChange={handleExpansionChange(2)}>
                <AccordionSummary sx={expansionPanelSummarySx}>
                  {expansionStatus[2] ? <RemoveCircleOutlineRoundedIcon /> : <AddCircleOutlineRoundedIcon />}
                  <Typography sx={faqTitleSx}><Highlight search={search}>3. How long will it take me to complete this form?</Highlight></Typography>
                </AccordionSummary>
                <AccordionDetails sx={expansiondetailSx}>
                  <Typography><Highlight search={search}>The estimated average burden associated with this collection of information is 11 minutes per respondent or record keeper depending on individual circumstances. Comments concerning the accuracy of this burden estimate and suggestions for reducing this burden should be directed to the Department of the Treasury, Financial Crimes Enforcement Network, P.O. Box 39 Vienna, Virginia 22183.</Highlight></Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid sx={gridPanelSx}>
              <Accordion sx={expansionPanelSx} expanded={expansionStatus[3]} onChange={handleExpansionChange(3)}>
                <AccordionSummary sx={expansionPanelSummarySx}>
                  {expansionStatus[3] ? <RemoveCircleOutlineRoundedIcon /> : <AddCircleOutlineRoundedIcon />}
                  <Typography sx={faqTitleSx}><Highlight search={search}>4. Can I save the form to complete it at a later date or time?</Highlight></Typography>
                </AccordionSummary>
                <AccordionDetails sx={expansiondetailSx}>
                  <Typography><Highlight search={search}>The estimated average burden associated with this collection of information is 11 minutes per respondent or record keeper depending on individual circumstances. Comments concerning the accuracy of this burden estimate and suggestions for reducing this burden should be directed to the Department of the Treasury, Financial Crimes Enforcement Network, P.O. Box 39 Vienna, Virginia 22183.</Highlight></Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid sx={gridPanelSx}>
              <Accordion sx={expansionPanelSx} expanded={expansionStatus[4]} onChange={handleExpansionChange(4)}>
                <AccordionSummary sx={expansionPanelSummarySx}>
                  {expansionStatus[4] ? <RemoveCircleOutlineRoundedIcon /> : <AddCircleOutlineRoundedIcon />}
                  <Typography sx={faqTitleSx}><Highlight search={search}>5. Who must file?</Highlight></Typography>
                </AccordionSummary>
                <AccordionDetails sx={expansiondetailSx}>
                  <Typography><Highlight search={search}>a) Each person who physically transports, mails, or ships, or causes to be physically transported, mailed, or shipped currency or other monetary instruments in an aggregate amount exceeding $10,000 at one time from the United States to any place outside the United States or into the United States from any place outside the United States, </Highlight><br /> <br />
                    <Highlight search={search}>b) Each person who receives in the United States currency or other monetary instruments in an aggregate amount exceeding $10,000 at one time which have been transported, mailed, or shipped to the person from any place outside the United States, </Highlight> <br /> <br />
                    <Highlight search={search}>c) A common carrier of passengers in respect to currency or other monetary instruments in the possession of its passengers,and </Highlight> <br /> <br />
                    <Highlight search={search}>d) A common carrier of goods in respect to shipments of currency or monetary instruments not declared to be such by the shipper</Highlight> <br /> <br />
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>

            <Grid sx={gridPanelSx}>
              <Accordion sx={expansionPanelSx} expanded={expansionStatus[5]} onChange={handleExpansionChange(5)}>
                <AccordionSummary sx={expansionPanelSummarySx}>
                  {expansionStatus[5] ? <RemoveCircleOutlineRoundedIcon /> : <AddCircleOutlineRoundedIcon />}
                  <Typography sx={faqTitleSx}><Highlight search={search}>6. Who does not have to file?</Highlight></Typography>
                </AccordionSummary>
                <AccordionDetails sx={expansiondetailSx}>
                  <Typography> <Highlight search={search}> Reports are not required to be filed by </Highlight><br /> <br />
                    <Highlight search={search}>a)	a Federal Reserve bank,</Highlight>  <br /> <br />
                    <Highlight search={search}>b)	a bank, a foreign bank, or a broker or dealer in securities in respect to currency or other monetary instruments mailed or shipped through the postal service or by common carrier,</Highlight> <br /> <br />
                    <Highlight search={search}>c)	a commercial bank or trust company organized under the laws of any State or of the United States with respect to overland shipments of currency or monetary instruments shipped to or received from an established customer maintaining a deposit relationship with the bank, in amounts which the bank may reasonably conclude do not exceed amounts commensurate with the customary conduct of the business, industry, or profession of the customer concerned, </Highlight> <br />  <br />
                    <Highlight search={search}>d)	a person who is not a citizen or resident of the United States in respect to currency or other monetary instruments or shipped from abroad to a bank or broker or dealer in securities through the post al service or by common carrier,</Highlight> <br /> <br />
                    <Highlight search={search}>e)	a travelers’ check issuer or its agent in respect to the transportation of travelers’ checks prior to their delivery to selling agents for eventual sale to the public, </Highlight>  <br /> <br />
                    <Highlight search={search}>f)	a person with a restrictively endorsed traveler’s check that is in the collection and reconciliation process after the traveler’s check has been negotiated, nor by </Highlight> <br /> <br />
                    <Highlight search={search}>g)	a person engaged as a business in the transportation of currency, monetary instruments and other commercial papers with respect to the transportation of currency or other monetary instruments overland between established offices of banks or brokers or dealers in securities and foreign persons. </Highlight> <br /> <br />
                    <Highlight search={search}> A TRANSFER OF FUNDS THROUGH NORMAL BANKING PROCEDURES, WHICH DOES NOT INVOLVE THE PHYSICAL TRANSPORTATION OF CURRENCY OR MONETARY INSTRUMENTS, IS NOT REQUIRED TO BE REPORTED </Highlight> <br /> <br /></Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid sx={gridPanelSx}>
              <Accordion sx={expansionPanelSx} expanded={expansionStatus[6]} onChange={handleExpansionChange(6)}>
                <AccordionSummary sx={expansionPanelSummarySx}>
                  {expansionStatus[6] ? <RemoveCircleOutlineRoundedIcon /> : <AddCircleOutlineRoundedIcon />}
                  <Typography sx={faqTitleSx}><Highlight search={search}>7.	When do I need to submit the form?</Highlight></Typography>
                </AccordionSummary>
                <AccordionDetails sx={expansiondetailSx}>
                  <Typography> <Highlight search={search}>a. Travelers planning to carry currency or other monetary instruments with them must submit the form within three days (72 hours) prior to the planned travel date in or out of the United States.</Highlight><br /><br />
                    <Highlight search={search}>b. Recipients—Unless filed by the sender, each person who receives currency or other monetary instruments in the United States must submit the form within 15 days after receipt of the currency or monetary instruments.</Highlight> <br /><br />
                    <Highlight search={search}>c. Shippers or Mailers— lf the currency or other monetary instrument will not accompany the person entering or departing the United States, the form should be submitted on or before the date of mailing or shipping.</Highlight></Typography><br /><br />
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid sx={gridPanelSx}>
              <Accordion sx={expansionPanelSx} expanded={expansionStatus[7]} onChange={handleExpansionChange(7)}>
                <AccordionSummary sx={expansionPanelSummarySx}>
                  {expansionStatus[7] ? <RemoveCircleOutlineRoundedIcon /> : <AddCircleOutlineRoundedIcon />}
                  <Typography sx={faqTitleSx}><Highlight search={search}>8. What if my travel plans change?</Highlight></Typography>
                </AccordionSummary>
                <AccordionDetails sx={expansiondetailSx}>
                  <Typography><Highlight search={search}>Any change in travel plans may require you to fill out a new FinCEN 105 Form. Upon submission of the form, you have three days (72 hours) to arrive or depart the United States via a port of entry.  If you travel after the three days (72 hours), or to a different location than planned, you will be required to complete a new FinCEN Form 105.  If you decide to cancel your plans, no additional action is required.</Highlight></Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid sx={gridPanelSx}>
              <Accordion sx={expansionPanelSx} expanded={expansionStatus[8]} onChange={handleExpansionChange(8)}>
                <AccordionSummary sx={expansionPanelSummarySx}>
                  {expansionStatus[8] ? <RemoveCircleOutlineRoundedIcon /> : <AddCircleOutlineRoundedIcon />}
                  <Typography sx={faqTitleSx}><Highlight search={search}>9.	What if the amount I need to report changes after I submit the form?</Highlight></Typography>
                </AccordionSummary>
                <AccordionDetails sx={expansiondetailSx}>
                  <Typography><Highlight search={search}>If the amount of currency or monetary instruments that you need to report changes after you submit the form, you will be required to submit a new form with the correct amount.  The previous form you submitted will expire with no action required.</Highlight></Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid sx={gridPanelSx}>
              <Accordion sx={expansionPanelSx} expanded={expansionStatus[9]} onChange={handleExpansionChange(9)}>
                <AccordionSummary sx={expansionPanelSummarySx}>
                  {expansionStatus[9] ? <RemoveCircleOutlineRoundedIcon /> : <AddCircleOutlineRoundedIcon />}
                  <Typography sx={faqTitleSx}><Highlight search={search}>10. What exchange rate do I use?</Highlight></Typography>
                </AccordionSummary>
                <AccordionDetails sx={expansiondetailSx}>
                  <Typography><Highlight search={search}>The exchange rate is calculated automatically. You do not need to figure out the exchange rate.  Note that if the total calculation does not amount to $10,000 USD or more, you do not have to file the form.</Highlight></Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid sx={gridPanelSx}>
              <Accordion sx={expansionPanelSx} expanded={expansionStatus[10]} onChange={handleExpansionChange(10)}>
                <AccordionSummary sx={expansionPanelSummarySx}>
                  {expansionStatus[10] ? <RemoveCircleOutlineRoundedIcon /> : <AddCircleOutlineRoundedIcon />}
                  <Typography sx={faqTitleSx}><Highlight search={search}>11. Do I need to fill out the paper form in addition to electronic version?</Highlight></Typography>
                </AccordionSummary>
                <AccordionDetails sx={expansiondetailSx}>
                  <Typography><Highlight search={search}>No.  If you have completed and submitted the form on the website, you do not need to complete a paper version of FinCEN Form 105</Highlight></Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid sx={gridPanelSx}>
              <Accordion sx={expansionPanelSx} expanded={expansionStatus[11]} onChange={handleExpansionChange(11)}>
                <AccordionSummary sx={expansionPanelSummarySx}>
                  {expansionStatus[11] ? <RemoveCircleOutlineRoundedIcon /> : <AddCircleOutlineRoundedIcon />}
                  <Typography sx={faqTitleSx}><Highlight search={search}>12. Can I fill out the form at a port of entry?</Highlight></Typography>
                </AccordionSummary>
                <AccordionDetails sx={expansiondetailSx}>
                  <Typography><Highlight search={search}>Yes. The website is mobile-friendly and is accessible on smart phones, tablets and laptop computers.  A connection to the Internet is required.  Once you submit the form at a port of entry, provide your confirmation number to the officer for processing.</Highlight></Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid sx={gridPanelSx}>
              <Accordion sx={expansionPanelSx} expanded={expansionStatus[12]} onChange={handleExpansionChange(12)}>
                <AccordionSummary sx={expansionPanelSummarySx}>
                  {expansionStatus[12] ? <RemoveCircleOutlineRoundedIcon /> : <AddCircleOutlineRoundedIcon />}
                  <Typography sx={faqTitleSx}><Highlight search={search}>13. Does the form expire?</Highlight></Typography>
                </AccordionSummary>
                <AccordionDetails sx={expansiondetailSx} >
                  <Typography><Highlight search={search}>Yes. Upon submission, the form is valid for three days (72 hours).  You must travel to a port of entry within three days (72 hours) and present your valid receipt with confirmation number.  Travel after the three days (72 hours) will require a new FinCEN Form 105.</Highlight></Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>

            <Grid sx={gridPanelSx}>
              <Accordion sx={expansionPanelSx} expanded={expansionStatus[13]} onChange={handleExpansionChange(13)}>
                <AccordionSummary sx={expansionPanelSummarySx}>
                  {expansionStatus[13] ? <RemoveCircleOutlineRoundedIcon /> : <AddCircleOutlineRoundedIcon />}
                  <Typography sx={faqTitleSx}><Highlight search={search}>14. What do I do after I submit the form?</Highlight></Typography>
                </AccordionSummary>
                <AccordionDetails sx={expansiondetailSx} >
                  <Typography><Highlight search={search}>Once you complete the form and endorse it online, you may print or save the confirmation receipt, or email it.  When you travel, present the receipt or provide your confirmation number to the Customs and Border Protection (CBP) officer at the port of entry.</Highlight></Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>

            <Grid sx={gridPanelSx}>
              <Accordion sx={expansionPanelSx} expanded={expansionStatus[14]} onChange={handleExpansionChange(14)}>
                <AccordionSummary sx={expansionPanelSummarySx}>
                  {expansionStatus[14] ? <RemoveCircleOutlineRoundedIcon /> : <AddCircleOutlineRoundedIcon />}
                  <Typography sx={faqTitleSx}><Highlight search={search}>15. Why is the ‘Next’ button greyed out?</Highlight></Typography>
                </AccordionSummary>
                <AccordionDetails sx={expansiondetailSx} >
                  <Typography><Highlight search={search}>The ‘Next’ button will remain greyed out if required fields are not filled out, or if incorrect information is entered (for example, if a future date is selected for the Date of Birth). Once the fields are complete or the errors are corrected, the ‘Next’ button will be activated.</Highlight></Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid sx={gridPanelSx}>
              <Accordion sx={expansionPanelSx} expanded={expansionStatus[15]} onChange={handleExpansionChange(15)}>
                <AccordionSummary sx={expansionPanelSummarySx}>
                  {expansionStatus[15] ? <RemoveCircleOutlineRoundedIcon /> : <AddCircleOutlineRoundedIcon />}
                  <Typography sx={faqTitleSx}><Highlight search={search}>16. Do I have to write my name in the signature box?</Highlight></Typography>
                </AccordionSummary>
                <AccordionDetails sx={expansiondetailSx} >
                  <Typography><Highlight search={search}>The signature box is an optional field. You may use your computer's mouse or your finger(if you have touch screen device) to draw a signature.</Highlight></Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid sx={gridPanelSx}>
              <Accordion sx={expansionPanelSx} expanded={expansionStatus[16]} onChange={handleExpansionChange(16)}>
                <AccordionSummary sx={expansionPanelSummarySx}>
                  {expansionStatus[16] ? <RemoveCircleOutlineRoundedIcon /> : <AddCircleOutlineRoundedIcon />}
                  <Typography sx={faqTitleSx}><Highlight search={search}>17. What business information do I need to provide?</Highlight></Typography>
                </AccordionSummary>
                <AccordionDetails sx={expansiondetailSx} >
                  <Typography><Highlight search={search}>If you are transporting or mailing/shipping monetary instrument for a business, you will need to provide the business name, business identification number, and business address.</Highlight></Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid sx={gridPanelSx}>
              <Accordion sx={expansionPanelSx} expanded={expansionStatus[17]} onChange={handleExpansionChange(17)}>
                <AccordionSummary sx={expansionPanelSummarySx}>
                  {expansionStatus[17] ? <RemoveCircleOutlineRoundedIcon /> : <AddCircleOutlineRoundedIcon />}
                  <Typography sx={faqTitleSx}><Highlight search={search}>18. What if I don’t file?</Highlight></Typography>
                </AccordionSummary>
                <AccordionDetails sx={expansiondetailSx}>
                  <Typography><Highlight search={search}>No person otherwise required to file a report shall be excused from liability for failure to do so if, in fact, a complete and truthful report has not been filed. Civil and criminal penalties, including under certain circumstances a fine of not more than $500,000 and imprisonment of not more than ten years, are provided for failure to file a report, filing a report containing a material omission or misstatement, or filing a false or fraudulent report. In addition, the currency or monetary instrument may be subject to seizure and forfeiture. See 31 U.S.C.5321 and 31 CFR 1010.820; 31 U.S.C. 5322 and 31 CFR 1010.840; 31 U.S.C. 5317 and 31 CFR 1010.830, and U.S.C. 5332.</Highlight></Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid sx={gridPanelSx}>
              <Accordion sx={expansionPanelSx} expanded={expansionStatus[18]} onChange={handleExpansionChange(18)}>
                <AccordionSummary sx={expansionPanelSummarySx}>
                  {expansionStatus[18] ? <RemoveCircleOutlineRoundedIcon /> : <AddCircleOutlineRoundedIcon />}
                  <Typography sx={faqTitleSx}><Highlight search={search}>19. How will my information be used?</Highlight></Typography>
                </AccordionSummary>
                <AccordionDetails sx={expansiondetailSx}>
                  <Typography><Highlight search={search}>The information collected on the web-based form is the same that is collected today on the paper form.  The information on the form is reviewed by CBP officers and stored in a CBP database pursuant to  the same authorities as above (FAQ “Why do I have to provide this information?”). The principal purpose for collecting the information is to assure maintenance of reports or records where such reports or records have a high degree of usefulness in criminal, tax, or regulatory investigations or proceedings.  Information collected is also used to analyze foreign currency transactions to identify potential fraudulent or illegal activities and identify trends.</Highlight></Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid sx={gridPanelSx}>
              <Accordion sx={expansionPanelSx} expanded={expansionStatus[19]} onChange={handleExpansionChange(19)}>
                <AccordionSummary sx={expansionPanelSummarySx}>
                  {expansionStatus[19] ? <RemoveCircleOutlineRoundedIcon /> : <AddCircleOutlineRoundedIcon />}
                  <Typography sx={faqTitleSx}><Highlight search={search}>20. Can I still use the paper form?</Highlight></Typography>
                </AccordionSummary>
                <AccordionDetails sx={expansiondetailSx}>
                  <Typography><Highlight search={search}>The paper form is still available for use. You can find it</Highlight> <a rel="noopener noreferrer" target="_blank" href={'https://www.fincen.gov/sites/default/files/shared/fin105_cmir.pdf'}>here</a>.<Highlight search={search}> Please complete the form prior to your planned travel date and present it to the Customs and Border Protection (CBP) officer at the port of entry. You can also ask for a copy of the form at the port of entry and complete it there.</Highlight></Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid sx={gridPanelSx}>
              <Accordion sx={expansionPanelSx} expanded={expansionStatus[20]} onChange={handleExpansionChange(20)}>
                <AccordionSummary sx={expansionPanelSummarySx}>
                  {expansionStatus[20] ? <RemoveCircleOutlineRoundedIcon /> : <AddCircleOutlineRoundedIcon />}
                  <Typography sx={faqTitleSx}><Highlight search={search}>21. What is a Currency Transporter (Carrier)?</Highlight></Typography>
                </AccordionSummary>
                <AccordionDetails sx={expansiondetailSx}>
                  <Typography><Highlight search={search}>A Currency Transporter is a common carrier of currency that transports currency or other monetary instruments 
                as a business, for a person that engages the carrier for a fee (the “shipper”), from one place to another, to be delivered to the person appointed by the shipper 
                to receive the currency or other monetary instruments (the “consignee”). The shipper may be acting of its own accord or on instructions from a different person 
                (the “currency originator”), and the consignee may be instructed to deliver the currency or other monetary instruments to the account of a final beneficiary 
                (the “currency recipient”). The same person may fulfill more than one role in the same shipment. </Highlight>
                    <a rel="noopener noreferrer" target="_blank" href={'https://www.fincen.gov/sites/default/files/shared/fin105_cmir.pdf'}>here</a>.
                <Highlight search={search}> Please complete the form prior to your planned travel date and present it to the Customs and Border Protection (CBP) officer 
                at the port of entry. You can also ask for a copy of the form at the port of entry and complete it there.</Highlight> <br /><br />
                    <Highlight search={search}>
                      **<a rel="noopener noreferrer" target="_blank" href={'https://www.fincen.gov/resources/statutes-regulations/administrative-rulings/administrative-ruling-application-fincen'}>FIN-2014-R010 </a>
                      Administrative Ruling on the Application of FinCEN Regulations to Currency Transporters,
                Including Armored Car Services, and Exceptive Relief -- Issued Date: September 24, 2014.</Highlight> <br />
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid sx={gridPanelSx}>
              <Accordion sx={expansionPanelSx} expanded={expansionStatus[21]} onChange={handleExpansionChange(21)}>
                <AccordionSummary sx={expansionPanelSummarySx}>
                  {expansionStatus[21] ? <RemoveCircleOutlineRoundedIcon /> : <AddCircleOutlineRoundedIcon />}
                  <Typography sx={faqTitleSx}><Highlight search={search}>22. What is the limited exemption from filing for Common Carriers of Currency?</Highlight></Typography>
                </AccordionSummary>
                <AccordionDetails sx={expansiondetailSx}>
                  <Typography>       <Highlight search={search}> A.  The transportation consists of currency or other monetary instruments imported into the United States or exported out of the United States </Highlight><br /> <br />
                    <Highlight search={search}> B.	The transportation takes place overland. </Highlight> <br /> <br />
                    <Highlight search={search}> C.	The transportation takes place between a bank or a broker or dealer in securities, on the U.S. side, and a non-U.S. person, on the foreign side </Highlight> <br /> <br />
                    <Highlight search={search}> D.	The shipment is picked up or delivered at the established office of the bank or a broker or dealer in securities on the U.S. side</Highlight> <br /> <br />
                    <Highlight search={search}> ** All of the above four conditions have to be met</Highlight> <br />
                                ** <a rel="noopener noreferrer" target="_blank" href={'https://www.govinfo.gov/app/details/CFR-2016-title31-vol3/CFR-2016-title31-vol3-sec1010-340'}>31 CFR §1010.340 (c)(9)</a>
                    <Highlight search={search}> (common carrier of currency exemption).</Highlight> <br />

                  </Typography> <br />
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid sx={gridPanelSx}>
              <Accordion sx={expansionPanelSx} expanded={expansionStatus[22]} onChange={handleExpansionChange(22)}>
                <AccordionSummary sx={expansionPanelSummarySx}>
                  {expansionStatus[22] ? <RemoveCircleOutlineRoundedIcon /> : <AddCircleOutlineRoundedIcon />}
                  <Typography sx={faqTitleSx}><Highlight search={search}>23. What are the other exemptions that are not applicable to Common Carriers of Currency?</Highlight></Typography>
                </AccordionSummary>
                <AccordionDetails sx={expansiondetailSx}>
                  <Typography>
                    <Highlight search={search}>Although the CMIR regulations include a number of exemptions that apply to other parties, a common carrier of currency may not claim for itself any exemption for filing a CMIR that might be 
                  applicable to other parties. For example, banks, foreign banks or brokers or dealers in securities are themselves exempted from filing a CMIR with respect to currency or other monetary instruments that they mail or ship via 
                  the postal service or a common carrier. A common carrier of currency cannot apply this exemption to itself (although, as described above, the limited exemption may apply). For example, if a common carrier of currency picks up at 
                  an airport a cargo of currency air-shipped to a U.S. bank from abroad, the common carrier has an obligation to file a CMIR even though the bank does not
                  </Highlight> <a rel="noopener noreferrer" target="_blank" href={'https://www.fincen.gov/sites/default/files/shared/fin105_cmir.pdf'}>here</a>.
                  <Highlight search={search}> Please complete the form prior to your planned travel date and present it to the Customs and Border Protection (CBP) officer at the port of entry. You can also ask for a copy of the form at the
                   port of entry and complete it there.</Highlight> <br /> <br />
                  **<a rel="noopener noreferrer" target="_blank" href={'https://www.govinfo.gov/app/details/CFR-2016-title31-vol3/CFR-2016-title31-vol3-sec1010-340'}>31 CFR §1010.340 (c)</a>
                    <Highlight search={search}> (all exemptions).</Highlight>
                    <br />
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid sx={gridPanelSx}>
              <Accordion sx={expansionPanelSx} expanded={expansionStatus[23]} onChange={handleExpansionChange(23)}>
                <AccordionSummary sx={expansionPanelSummarySx}>
                  {expansionStatus[23] ? <RemoveCircleOutlineRoundedIcon /> : <AddCircleOutlineRoundedIcon />}
                  <Typography sx={faqTitleSx}><Highlight search={search}>24. Terms/Defintions</Highlight></Typography>
                </AccordionSummary>
                <AccordionDetails sx={expansiondetailSx}>
                  <Typography> <Highlight search={search}> A.	Bank—Each agent, agency, branch or office within the United States of any person doing business in one or more of the capacities listed: (1) a commercial bank or trust company organized under the laws of any State or of the United States; (2) a private bank; (3) a savings association, savings and loan association, and building and loan association organized under the laws of any State or of the United States; (4) an insured institution as defined in section 401 of the National Housing Act; (5) a savings bank, industrial bank or other thrift institution; (6) a credit union organized under the laws of any State or of the United States; (7) any other organization chartered under the banking laws of any State and subject to the supervision of the bank supervisory authorities of a State other than a money service business; (8) a bank organized under foreign law; and (9) any national banking association or corporation acting under the provisions of section 25A of the Federal Reserve Act (12 U.S.C. Sections 611-632).</Highlight><br /> <br />
                    <Highlight search={search}> B.	Foreign Bank—A bank organized under foreign law, or an agency, branch or office located outside the United States of a bank. The term does not include an agent, agency, branch or office within the United States of a bank organized under foreign law. </Highlight> <br /> <br />
                    <Highlight search={search}> C.	Broker or Dealer in Securities—A broker or dealer in securities, registered or required to be registered with the Securities and Exchange Commission under the Securities Exchange Act of 1934. </Highlight> <br /> <br />
                    <Highlight search={search}> D.	Currency: The coin and paper money of the United States or any other country that is (1) designated as legal tender and that (2) circulates and (3) is customarily accepted as a medium of exchange in the country of issuance.</Highlight> <br /> <br />
                    <Highlight search={search}> E.	Identification Number—Individuals must enter their social security number, if any. However, aliens who do not have a social security number should enter passport or alien registration number. All others should enter their employer identification number.</Highlight><br /> <br />
                    <Highlight search={search}> F.	Monetary Instruments— (1) Coin or currency of the United States or of any other country, (2) traveler’s checks in any form, (3) negotiable instruments (including checks, promissory notes, and money orders) in bearer form, endorsed without restriction, made out to a fictitious payee, or otherwise in such form that title thereto p asses upon delivery, (4) incomplete instruments (including checks, promissory notes, and money orders) that are signed but on which the name of the payee has been omitted, and (5) securities or stock in bearer form or otherwise in such form that title thereto passes upon delivery. Monetary instruments do not include (i) checks or money orders made payable to the order of a named person which have not been endorsed or which bear restrictive endorsements, (ii) warehouse receipts, or (iii) bills of lading.</Highlight><br /> <br />
                    <Highlight search={search}> G.	Person—An individual, a corporation, partnership, a trust or estate, a joint stock company, an association, a syndicate, joint venture or other unincorporated organization or group, an Indian Tribe (as that term is defined in the Indian Gaming Regulatory Act), and all entities cognizable as legal personalities.</Highlight> <br /> <br />
                    <Highlight search={search}> H.	Confirmation Number – A number generated automatically when you complete the form. It is a twelve-digit alpha-numeric sequence (for example, CM0000000001).</Highlight> <br /> <br />
                    <Highlight search={search}> I.	Common Carrier – Any person engaged in the business of transporting individuals or goods for a fee who holds itself out as ready to engage in such transportation for hire and who undertakes to do so indiscriminately for all persons who are prepared to pay the fee for the particular service offered.</Highlight>
                                **<a rel="noopener noreferrer" target="_blank" href={'https://www.govinfo.gov/app/details/CFR-2011-title31-vol3/CFR-2011-title31-vol3-sec1010-100'}>31 CFR §1010.100 (k)</a> <Highlight search={search}> (definition of ‘common carrier’).</Highlight> <br /><br />
                    <Highlight search={search}> J.	Armored Car Service – A subgroup of common carriers, those persons engaged as a business in the transportation of currency, other monetary instruments, or commercial papers, referred to herein as “common carriers of currency.”</Highlight></Typography> <br />
                </AccordionDetails>
              </Accordion>
            </Grid>
          </Grid>
        </Grid>
        {displayUpButton ?
          <div> <button style={scrollToTopSx} onClick={handleScrollToTop}><ArrowUpwardIcon /><div style={scrollToTopTextSx}>TOP</div></button></div> : null}
      </Box>
    </Box>

  );
}

export default Help;